module.exports = __webpack_public_path__ + "media/src/images/logos/instagram-logo-outline-ac084c268de7f6f4fcb48d60434d486c.png";